import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChartsModule } from 'ng2-charts';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NewDashboardComponent } from './new-dashboard/new-dashboard.component';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';



import { AlertComponent } from './_components'; 
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { SpinnerService } from './_services/spinner.service';
import { SpinnerComponent } from './_components/spinner component/spinner.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppConfigService, AppConfigModule} from './_helpers/app-config.service';
import { GenericPopupGridModule } from './generic-grid/generic-popup-grid.module'

// import { NpDatepickerModule } from 'angular-nepali-datepicker';
// used to create fake backend
// import { fakeBackendProvider } from './_helpers';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    AlertComponent,
    SpinnerComponent,
    NewDashboardComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ChartsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    GenericPopupGridModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    SpinnerService,
    AppConfigService,
    AppConfigModule.init()
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
